import React from 'react'

//styles
import "./Navbar.css"

//icons
import { FaBagShopping, FaBars, FaUser } from "react-icons/fa6";
import Search, { SearchProps } from 'antd/es/input/Search';
import { useNavigate } from 'react-router-dom';


interface Props{
    setOpen:React.Dispatch<React.SetStateAction<boolean>>
}

const Navbar = ({setOpen}:Props) => {
  const navigate = useNavigate();

  const onSearch: SearchProps['onSearch'] = (value, _e, info) => console.log(info?.source, value);
  
  return (
    <div className='navbar-component'>
      <div className='navbar-content'>
        <div className='navbar-logo'>
            <img src='/logo.png' alt='Logo frikistore' />
        </div>
        <div className='navbar-links'>
            {/* <div className='navbar-link' onClick={()=>{navigate("/inicio")}}>Inicio</div>
            <div className='navbar-link' onClick={()=>{navigate("/productos")}}>Productos</div>
            <div className='navbar-link' onClick={()=>{navigate("/productos")}}>Sobre nosotros</div> */}
            <span></span>

        </div>

        <div className='navbar-end'>
          {/* <div className='navbar-search'>
            <Search className='navbar-search-input' placeholder="Ingresa la busqueda" allowClear onSearch={onSearch} />
          </div> */}

          {/* <div className='navbar-card'>
            <FaBagShopping size={20} />
          </div> */}

          {/* <div className='navbar-acount'>
            <FaUser size={20} />
          </div> */}

          <div className='navbar-movil-menu' onClick={()=>{setOpen(true)}}>
            <FaBars size={20} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar